import React from 'react';
import { useLanguage } from '@/context/language-context';

interface SearchResultsSummaryProps {
  resultsCount: number;
  searchQuery?: string;
  activeFiltersCount: number;
  isLoading?: boolean;
}

const SearchResultsSummary: React.FC<SearchResultsSummaryProps> = ({
  resultsCount,
  searchQuery,
  activeFiltersCount,
}) => {
  const { t } = useLanguage();

  // Format the display message based on search criteria
  const formatDisplayMessage = () => {
    if (searchQuery && activeFiltersCount > 0) {
      return (
        <>
          <span>{t('search.showing_results', { query: searchQuery })}</span>
          <span className="mx-1">{t('search.and')}</span>
          <span>{t('search.with_filters', { count: activeFiltersCount })}</span>
        </>
      );
    }
    
    if (searchQuery) {
      return <span>{t('search.showing_results', { query: searchQuery })}</span>;
    }
    
    if (activeFiltersCount > 0) {
      return (
        <>
          <span>{t('search.showing')}</span>
          <span className="mx-1">{resultsCount}</span>
          <span>{t('search.results_for')}</span>
          <span className="mx-1">{activeFiltersCount}</span>
          <span>{t('search.active_filters')}</span>
        </>
      );
    }

    return <span>{t('search.showing_all')}</span>;
  };

  return (
    <div className="flex items-center text-sm text-muted-foreground mb-4">
      <span className="font-medium text-foreground mr-1">
        {t('search:search.results', { count: resultsCount })}:
      </span>
      {formatDisplayMessage()}
    </div>
  );
};

export default SearchResultsSummary;
